module.exports = __webpack_public_path__ + "img/zs06.cd0f58f9.jpg";